<template>
  <v-row align="center" justify="center">
    <v-btn icon small @click="onShowRemarks" v-if="!itemIsExtra">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="primary" small v-on="on">mdi-note-outline</v-icon>
        </template>
        <span>Remarks</span>
      </v-tooltip>
    </v-btn>
    <v-btn
      icon
      small
      @click="onShowItemPricingEditor"
      v-if="serviceType != 'MANDATORY_CHARGES'"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            :color="item.customPricing ? 'green darken-2' : 'grey'"
            small
            v-on="on"
            >{{
              item.customPricing ? "mdi-currency-usd" : "mdi-currency-usd-off"
            }}</v-icon
          >
        </template>

        <span>Pricing</span>
      </v-tooltip>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: "itinerary-details-items-list-actions",

  props: {
    itemIsExtra: { type: Boolean, default: () => false },
    serviceType: { type: String, default: () => "" },
    item: { type: Object, default: () => null },
  },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
  },

  methods: {
    onShowRemarks() {
      if (this.params) {
        this.params.context.componentParent.onShowRemarks(this.itemData);
      } else {
        this.$emit("showRemarks", this.item);
      }
    },
    onShowItemPricingEditor() {
      if (this.params) {
        this.params.context.componentParent.onShowItemPricingEditor(
          this.itemData
        );
      } else {
        this.$emit("showItemPricingEditor", this.item);
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsItemsListActions.vue